export function addHourAfter(time: string): string {
  const [hh, mm] = time.split(':')
  const hours = Number(hh)
  const minutes = Number(mm)
  if (
    Number.isNaN(hours) ||
    Number.isNaN(minutes) ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59
  ) {
    return time
  }

  const totalMinutes = hours * 60 + minutes + 60
  const clampedMinutes = Math.min(20 * 60, totalMinutes)
  const nextHours = Math.floor(clampedMinutes / 60)
  const nextMinutes = clampedMinutes % 60
  const nextHh = String(nextHours).padStart(2, '0')
  const nextMm = String(nextMinutes).padStart(2, '0')
  return `${nextHh}:${nextMm}`
}

export function addHourBefore(time: string): string {
  const [hh, mm] = time.split(':')
  const hours = Number(hh)
  const minutes = Number(mm)
  if (
    Number.isNaN(hours) ||
    Number.isNaN(minutes) ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59
  ) {
    return time
  }

  const totalMinutes = hours * 60 + minutes - 60
  const clampedMinutes = Math.max(6 * 60, totalMinutes)
  const nextHours = Math.floor(clampedMinutes / 60)
  const nextMinutes = clampedMinutes % 60
  const nextHh = String(nextHours).padStart(2, '0')
  const nextMm = String(nextMinutes).padStart(2, '0')
  return `${nextHh}:${nextMm}`
}

export function isTimeOnOrAfter(start: string, end: string): boolean {
  if (!start || !end) return false
  return start >= end
}
